export default "__VITE_ASSET__d437c4e1__"